import { Row, Col, Image } from 'react-bootstrap';
import { HeadCell, Cell } from 'components/gifts-table/TableList';
import { PriceCell } from 'components/gifts-table/Cells';
import CurrencyFormat from 'components/Helpers/CurrencyFormat';

import styles from './styles.module.scss';

const giftCell = (data = { article: {} }) => {
  const { image, productName, description, id, refundQuantity, paidQuantity } = data.article || {};

  const CardCell = () => (
    <td className="cardCell" id={id}>
      <Row>
        <Col xs={5}>
          <Image src={image} className="cardCell__image" />
        </Col>
        <Col
          xs={6}
          className="d-flex col-6 flex-column align-items-start justify-content-center"
        >
          <div>
            <p className="font-weight-bold">{productName}</p>
            <p>{description}</p>
            {paidQuantity > refundQuantity ? <p className="text-muted"><h6><small>({paidQuantity}) Pagados</small></h6></p> : null}
            {refundQuantity ? <p className="text-muted"><h6><small>({refundQuantity}) Reembolsados</small></h6></p> : null}
          </div>
        </Col>
      </Row>
    </td>
  );

  return (
    <>
      {data.isBody && !data.isHeader ? CardCell() : <HeadCell column={data} />}
    </>
  );
};

export const columns = () => [
  {
    label: { label: 'ARTÍCULO' },
    field: 'article',
    align: 'center',
    weight: 'bold',
    renderer: giftCell,
  },
  {
    label: 'CANTIDAD',
    field: 'amount',
    align: 'center',
  },
  {
    label: 'PRECIO UNITARIO',
    field: 'unitPrice',
    align: 'center',
    renderer: (props) => <PriceCell {...props} />,
  },
];

export const mobileColumns = () => [
  {
    label: 'REGALO',
    field: 'status',
    align: 'center',
    weight: 'bold',
    noRenderer: true,
    singleMobileCell: true,
    renderer: (props = {}, column, item = {}) => {
      const { isBody, unitPrice, amount } = props;
      const { image, productName } = props.article || {};

      return (
        <>
          {isBody ? (
            <div
              className={`${styles.giftProductTableCard} d-flex justify-content-around flex-wrap align-items-center my-4`}
            >
              <div
                className={`${styles.productImage} d-flex align-items-center px-1 px-sm-2`}
              >
                <img src={image} alt={productName} />
              </div>

              <div className="d-flex flex-column">
                <h6 className="font-weight-bold">{productName}</h6>

                <div className="d-flex justify-content-between">
                  <p>
                    <CurrencyFormat className="d-inline" price={unitPrice} />
                  </p>
                  <p>{amount}</p>
                </div>
              </div>
            </div>
          ) : (
            <div className="py-4">
              <Cell {...props} column={column} item={item} />
            </div>
          )}
        </>
      );
    },
  },
];
